import Vue from 'vue'
import App from './App.vue'
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import router from "./services/app_routes";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faGoogle} from "@fortawesome/free-brands-svg-icons";
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import "./assets/app.css";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueAnalytics from "vue-analytics";

library.add(faGoogle, faTimesCircle);


import store from "./store";

Vue.use(VueAnalytics, {
  id: "UA-165853515-1",
  router
});

Vue.config.devtools = true;
Vue.use(VueSweetalert2);

//Vue.config.productionTip = false;
store.dispatch("initializeGoogleApi");

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
